import formatDateLabel from '../../V5Gadget/formatDateLabel';

// +1 as we are pushing their start of week backwards
export const getDateLabel = (
  date: string,
  cadence?: 'day' | 'week' | 'month',
) => {
  if (cadence === 'day' || cadence === 'month') {
    return formatDateLabel(date, cadence, true);
  }
  return formatDateLabel(date, 'week', true);
};
